import { render, staticRenderFns } from "./VTableProPatientList.vue?vue&type=template&id=76aa84f0"
import script from "./VTableProPatientList.vue?vue&type=script&lang=js"
export * from "./VTableProPatientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports